import { createContext, useContext, useMemo, type ReactNode } from 'react';

interface CartCookbookBadgesValue {
  /**
   * Pairing ids that should render the "From your cookbook" badge — recipes
   * added by SmartCart / boxfill and favorited by the customer. Empty outside
   * the exp-242 mobile orders tab, so the badge never shows in the standalone
   * cart or other Cart hosts.
   */
  cookbookPairingIds: ReadonlySet<number>;
}

const EMPTY_PAIRING_IDS: ReadonlySet<number> = new Set();
const DEFAULT: CartCookbookBadgesValue = {
  cookbookPairingIds: EMPTY_PAIRING_IDS,
};

const CartCookbookBadgesContext =
  createContext<CartCookbookBadgesValue>(DEFAULT);

interface ProviderProps {
  cookbookPairingIds: ReadonlySet<number>;
  children: ReactNode;
}

export function CartCookbookBadgesProvider({
  cookbookPairingIds,
  children,
}: ProviderProps) {
  const value = useMemo(() => ({ cookbookPairingIds }), [cookbookPairingIds]);

  return (
    <CartCookbookBadgesContext.Provider value={value}>
      {children}
    </CartCookbookBadgesContext.Provider>
  );
}

export function useCartCookbookBadges(): CartCookbookBadgesValue {
  return useContext(CartCookbookBadgesContext);
}
